import MailIcon from "@mui/icons-material/Mail";
import { Avatar } from "@mui/material";
import { getAvatarText } from "@utils";

interface AssigneeAvatarProps {
  fullName: string;
  isUnassigned?: boolean;
}

export const AssigneeAvatar = ({
  fullName,
  isUnassigned,
}: AssigneeAvatarProps) => (
  <Avatar
    sx={{
      width: 24,
      height: 24,
      fontSize: "0.7rem",
      flexShrink: 0,
      bgcolor: isUnassigned ? "grey.300" : "secondary.main",
      color: isUnassigned ? "grey.500" : "secondary.contrastText",
    }}
  >
    {isUnassigned ? (
      <MailIcon sx={{ fontSize: "18px", color: "grey.500" }} />
    ) : (
      getAvatarText(fullName)
    )}
  </Avatar>
);
